import { render, staticRenderFns } from "./PerformanceTable.vue?vue&type=template&id=4203468d&scoped=true"
import script from "./PerformanceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PerformanceTable.vue?vue&type=style&index=0&id=4203468d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203468d",
  null
  
)

export default component.exports